import * as Sentry from '@sentry/react';

if (process.env.NODE_ENV === 'production') {
	Sentry.init({
		dsn: 'https://0007ab135f1c77e8eb581d2e18c76a9f@sentry-report.hstong.com/12',
		integrations: [
			new Sentry.reactRouterV6BrowserTracingIntegration({
				// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
				tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
			}),
			// new Sentry.replayIntegration({
			// 	maskAllText: false,
			// 	blockAllMedia: false,
			// }),
		],
		// Performance Monitoring
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// Session Replay
		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	});
}
const customReportErr = (message, errInfo) => {
	Sentry.captureEvent({
		message,
		level: 'error', // 或 'info', 'warning', 'critical'
		extra: {
			additionalInfo: errInfo,
		},
	});
};

export default customReportErr;
